export const HistorySectionType = {
  MEDICAL: 1,
  FAMILY: 2,
  SOCIAL: 3,
  SURGICAL: 4,
  HOSPITAL: 5,
};

export const MedicalHistoryCategory = {
  HEAD: 1,
  EYES: 2,
  EARS: 3,
  NOSE: 4,
  MOUTH: 5,
  CARDIO: 6,
  RESPI: 7,
  GASTRO: 8,
  GENI: 9,
  ENDO: 10,
  HEME: 11,
  INFECT: 12,
  MUSCU: 13,
  SKIN: 14,
  NEURO: 15,
  PSYCH: 16,
  NONE: 17,
  CUSTOM: 18,

  properties: {
    1: { name: 'Head', value: 1 },
    2: { name: 'Eyes', value: 2 },
    3: { name: 'Ears', value: 3 },
    4: { name: 'Nose/Sinuses', value: 4 },
    5: { name: 'Mouth/Throat/Teeth', value: 5 },
    6: { name: 'Cardiovascular', value: 6 },
    7: { name: 'Respiratory', value: 7 },
    8: { name: 'Gastrointestinal', value: 8 },
    9: { name: 'Genitourinary', value: 9 },
    10: { name: 'Endocrine', value: 10 },
    11: { name: 'Heme/Onc', value: 11 },
    12: { name: 'Infectious', value: 12 },
    13: { name: 'Musculoskeletal', value: 13 },
    14: { name: 'Skin', value: 14 },
    15: { name: 'Neurological', value: 15 },
    16: { name: 'Psychiatric', value: 16 },
    17: { name: 'None', value: 17 },
    18: { name: 'Miscellaneous', value: 18 },
  },
};

export const MedicalHistoryCategoriesMap1 = {
  [MedicalHistoryCategory.HEAD]: 'Head',
  [MedicalHistoryCategory.EYES]: 'Eyes',
  [MedicalHistoryCategory.EARS]: 'Ears',
  [MedicalHistoryCategory.NOSE]: 'Nose/Sinuses',
  [MedicalHistoryCategory.MOUTH]: 'Mouth/Throat/Teeth',
  [MedicalHistoryCategory.CARDIO]: 'Cardiovascular',
  [MedicalHistoryCategory.RESPI]: 'Respiratory',
  [MedicalHistoryCategory.GASTRO]: 'Gastrointestinal',
  [MedicalHistoryCategory.GENI]: 'Genitourinary',
};

export const MedicalHistoryCategoriesMap2 = {
  [MedicalHistoryCategory.ENDO]: 'Endocrine',
  [MedicalHistoryCategory.HEME]: 'Heme/Onc',
  [MedicalHistoryCategory.INFECT]: 'Infectious',
  [MedicalHistoryCategory.MUSCU]: 'Musculoskeletal',
  [MedicalHistoryCategory.SKIN]: 'Skin',
  [MedicalHistoryCategory.NEURO]: 'Neurological',
  [MedicalHistoryCategory.PSYCH]: 'Psychiatric',
};

export const SocialHistoryCategory = {
  TOBACCO: 1,
  ALCOHOL: 2,
  DRUG: 3,
  CARDIO: 4,
  SAFETY: 5,
  SEXUAL: 6,
  GENDER: 7,
  NONE: 8,
  CUSTOM: 9,

  properties: {
    1: { name: 'Tobacco', value: 1 },
    2: { name: 'Alcohol', value: 2 },
    3: { name: 'Drug Abuse', value: 3 },
    4: { name: 'Cardiovascular', value: 4 },
    5: { name: 'Safety', value: 5 },
    6: { name: 'Sexual Activity', value: 6 },
    7: { name: 'Birth Gender', value: 7 },
    8: { name: 'None', value: 8 },
    9: { name: 'Miscellaneous', value: 9 },
  },
};

export const SocialHistoryCategoriesMap1 = {
  [SocialHistoryCategory.TOBACCO]: 'Tobacco',
  [SocialHistoryCategory.ALCOHOL]: 'Alcohol',
  [SocialHistoryCategory.DRUG]: 'Drug Abuse',
};

export const SocialHistoryCategoriesMap2 = {
  [SocialHistoryCategory.CARDIO]: 'Cardiovascular',
  [SocialHistoryCategory.SAFETY]: 'Safety',
  [SocialHistoryCategory.SEXUAL]: 'Sexual Activity',
  [SocialHistoryCategory.GENDER]: 'Birth Gender',
};

// Object not returned from API call
export const SocialHistoryCategoryNone = {
  category: SocialHistoryCategory.NONE,
  label:
    'Please check here if you have traveled domestically or internationally within the past 6 months.',
  name: 'Traveled - internationally',
  checkboxKey: `${SocialHistoryCategory.NONE}:checkbox-Traveled - internationally`,
};
